// extracted by mini-css-extract-plugin
module.exports = {"upgradeButton":"UpgradeToProButton_upgradeButton__eMUnL","title":"UpgradeToProButton_title__y1T3o"};